// adminfrontend/src/admin_ui/services/adminLogisticsApi.js
import adminApiClient from "./adminApiClient";

const adminLogisticsApi = {
  async listShipments(params) {
    const res = await adminApiClient.get("/api/logistics/shipments", { params });
    return res.data;
  },

  async createShipment(payload) {
    const res = await adminApiClient.post("/api/logistics/shipments", payload);
    return res.data;
  },

  async getShipment(id) {
    const res = await adminApiClient.get(`/api/logistics/shipments/${id}`);
    return res.data;
  },

  async addShipmentEvent(id, payload) {
    const res = await adminApiClient.post(`/api/logistics/shipments/${id}/events`, payload);
    return res.data;
  },

  async approvePendingShipment(id, { note } = {}) {
    try {
      const res = await adminApiClient.post(`/api/logistics/shipments/${id}/pending/approve`, {
        note,
      });
      return res.data;
    } catch (e) {
      return { ok: false, error: e?.response?.data?.error || e.message || "Request failed" };
    }
  },

  async rejectPendingShipment(id, { note } = {}) {
    try {
      const res = await adminApiClient.post(`/api/logistics/shipments/${id}/pending/reject`, {
        note,
      });
      return res.data;
    } catch (e) {
      return { ok: false, error: e?.response?.data?.error || e.message || "Request failed" };
    }
  },
};

export default adminLogisticsApi;
